import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AddNotification } from 'acscp/actions';
import { defineMessages, FormattedMessage } from 'react-intl';
import { NotificationType } from 'acscp/store/notificationState';
import { home } from 'acscp/components/routeHelper';

const messages = defineMessages({
    expiredNotification: {
        id: 'components.booking.unavailableBooking.expiredNotification',
        defaultMessage: 'The booking you requested has expired.',
    },
    flownNotification: {
        id: 'components.booking.unavailableBooking.flownNotification',
        defaultMessage: 'The booking you requested has completed.',
    },
});

interface UnavailableBookingOwnProps {
    notificationCause: string;
    notificationMessage: FormattedMessage.MessageDescriptor;
}

interface UnavailableBookingDispatchProps {
    showNotification: () => void;
}

class UnavailableBookingPresentational
    extends React.Component<UnavailableBookingOwnProps & UnavailableBookingDispatchProps> {

    componentDidMount(): void {
        this.props.showNotification();
    }
    render(): JSX.Element {
        return <Redirect to={home()} />;
    }
}

function mapDispatchToProps(
    dispatch: Dispatch,
    ownProps: UnavailableBookingOwnProps
): UnavailableBookingDispatchProps {
    return {
        showNotification: () => dispatch(new AddNotification(
            ownProps.notificationCause, ownProps.notificationMessage, NotificationType.Error)),
    };
}

const UnavailableBooking = connect(undefined, mapDispatchToProps)(UnavailableBookingPresentational);

const ExpiredBooking: React.SFC<{}> = () => (
    <UnavailableBooking
        notificationCause={'UnavailableBookingExpired'}
        notificationMessage={messages.expiredNotification}
    />
);
const FlownBooking: React.SFC<{}> = () => (
    <UnavailableBooking
        notificationCause={'UnavailableBookingFlown'}
        notificationMessage={messages.flownNotification}
    />
);

export { ExpiredBooking, FlownBooking };
